import Vue from "vue";
import App from "./App";
import router from "./router";
import moment from "vue-moment";
import BootstrapVue from "bootstrap-vue";
import VueSidebarMenu from "vue-sidebar-menu";
import VueCurrencyFilter from "vue-currency-filter";
import VueCookies from "vue-cookies";
import Vue2Editor from "vue2-editor";
import VoerroTagsInput from '@voerro/vue-tagsinput';

import _ from "lodash";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import "./assets/css/desktop.css";
import "./assets/css/mobile.css";
import "./assets/css/tablet.css";
import "./assets/css/animate.css";
import "./assets/js/font-awesome-min";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTrashAlt,
  faPen,
  faCube,
  faGlobe,
  faUser,
  faSignOutAlt,
  faPlusCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faUser,
  faSignOutAlt,
  faGlobe,
  faCube,
  faPen,
  faTrashAlt,
  faPlusCircle
);

Vue.use(VueCookies);

VueCookies.config("1d");

Vue.use(VueCurrencyFilter, {
  symbol: "R$",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true
});

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component('tags-input', VoerroTagsInput);
Vue.use(moment);

Vue.use(BootstrapVue);
Vue.use(VueSidebarMenu);
Vue.use(Vue2Editor);

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js